<template>
  <div>
    <div class="text-xs-right">
      <v-btn icon @click="$emit('close')"> <v-icon>close</v-icon></v-btn>
    </div>
    <div class="px-3 pb-3">
      <Typography
        class="mb-2"
        h2
        bold
        :label="edittype === 'create' ? 'เพิ่มหน่วยร่วม' : 'แก้ไขหน่วยร่วม'"
      />
      <Typography h5 semiBold label="ชื่อหน่วยร่วม*" />
      <div class="form-control px-1 pb-2" :class="{ 'has-error': errors.has('name') }">
        <input
          v-validate="'required'"
          name="name"
          :style="{ backgroundColor: edittype == 'edit' ? '#eee' : '' }"
          :disabled="edittype == 'edit'"
          type="text"
          v-model="input.name"
        />
        <p class="text-error" v-if="errors.has('name')">{{ errors.first('name') }}</p>
      </div>
      <Typography h5 semiBold label="จังหวัด*" />
      <div class="form-control pb-4" :class="{ 'has-error': errors.has('Province') }">
        <multiselect
          name="Province"
          v-validate="'required'"
          :close-on-select="false"
          :options="ProvinceOptions"
          v-model="input.province"
          :placeholder="$t('Province')"
          :multiple="true"
          class="multi-tag-small"
        >
          <span slot="caret" :slot-scope="{ toggle }" class="arrow">
            <v-icon class="darkBlue" aria-hidden="false" size="24px">
              mdi-chevron-down
            </v-icon>
          </span>
        </multiselect>
        <p class="text-error" v-if="errors.has('Province')">{{ errors.first('Province') }}</p>
        <!-- <div class="text-xs-right">
          <v-btn @click="ClearAllProvince()" flat small color="primary"> Clear all</v-btn>
          <v-btn @click="selectAllProvince()" depressed color="primary" small> Select all</v-btn>
        </div> -->
        <div class="text-xs-right">
          <v-btn
            style="text-decoration: underline; width: 50px; color: #26588b"
            @click="ClearAllProvince()"
            flat
            small
          >
            <Typography h6 semiBold label="ล้างทั้งหมด"
          /></v-btn>
          <v-btn @click="selectAllProvince()" depressed :color="'#BECCDB'" small>
            <Typography h6 semiBold label="เลือกทั้งหมด" />
          </v-btn>
        </div>
      </div>
      <!-- <div class="text-xs-center pt-3">
        <v-btn @click="$emit('close')" outline color="grey">Cancel</v-btn>
        <v-btn :loading="saveloading" @click="saveData" depressed color="primary">Save</v-btn>
      </div> -->
      <div style="display: flex; justify-content: center">
        <Button :loading="saveloading" outline :label="$t('cancel')" @click="$emit('close')" />
        <Button :loading="saveloading" depressed :label="$t('Save')" @click="saveData" />
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import multiselect from 'vue-multiselect'
import Province from './Province.js'
import Button from '@/components/elements/Button.vue'
import Typography from '@/components/elements/Typography.vue'
export default {
  props: ['edittype', 'editdata'],
  components: {
    multiselect,
    Button,
    Typography
  },
  data() {
    return {
      saveloading: false,
      input: { name: '', province: [] },
      ProvinceOptions: Province
    }
  },
  mounted() {
    if (this.edittype == 'edit') {
      this.input.name = this.editdata.name
      this.input.province = this.editdata.provincelist
    }
  },
  methods: {
    async saveData() {
      var isValid = await this.$validator.validate()
      if (isValid) {
        var data, url
        data = {
          pageid: this.selectedBot.pageid,
          name: this.input.name,
          provincelist: this.input.province.join(',')
        }
        if (this.edittype == 'create') {
          url = 'createDepaAgencyMaster'
        } else {
          url = 'updateDepaAgencyMaster'
        }
        this.saveloading = true
        api[url](data, (err, response) => {
          this.saveloading = false
          if (response.responsecode == 200) {
            this.$emit('onsave')
            if (this.edittype == 'create') {
              this.$swal.fire({
                type: 'success',
                title: '<div class="headline primary--text bold7 fs-24">บันทึกข้อมูลสำเร็จ</div>',
                confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
              })
            } else {
              this.$swal.fire({
                type: 'success',
                title: '<div class="headline primary--text bold7 fs-24">แก้ไขข้อมูลสำเร็จ</div>',
                confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
              })
            }
          }
        })
      }
    },
    selectAllProvince(key) {
      this.input.province = this.ProvinceOptions
    },
    ClearAllProvince(key) {
      this.input.province = []
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/techhuntMaster/AgencyEdit.vue